<template>
  <v-app>
    <Snackbar :SnackBarComponent="SnackBarComponent"></Snackbar>
    <Overlay :overlay="overlay" />

    <AssetDetailsPageLoginPage v-if="current_view === 'ASSET_DETAILS'" @clicked="AssetDetailsPageLoginPageEMit">
    </AssetDetailsPageLoginPage>

    <v-main class="d-flex align-center justify-center whole-background" v-if="current_view === 'LOGIN_PAGE'">
      <v-container fluid v-if="mounted">
        <v-row justify="center" align="center">
          <v-col cols="12" md="10" lg="8">
            <v-card elevation="12" class="rounded-xl overflow-hidden">
              <v-row no-gutters>
                <v-col cols="12" md="6" class="md-and-up-only">
                  <v-card class="card-background"> </v-card>
                </v-col>

                <v-col cols="12" md="6" class="pa-8">
                  <div align="center" class="mb-2">
                    <v-img width="157" cover src="@/assets/EztrackBlackLogo.png"></v-img>
                  </div>
                  <v-window v-model="step" class="px-1">
                    <v-window-item :value="1">
                      <h1 class="mb-1 text-center">Welcome Back!</h1>
                      <p class="fontVariant3 mb-4 text-center">
                        Enter your email to get started
                      </p>
                      <v-form ref="form">
                        <v-text-field color="primary" v-model="EmailID" label="Email Address*"
                          placeholder="Enter your email" variant="outlined" :rules="[
                            (v) => !!v || 'Email is required',
                            (v) =>
                              /^\S+@\S+\.\S+$/.test(v) ||
                              'Invalid email format',
                          ]" class="mb-4" required @keydown.enter.prevent="validateSignInForm">
                          <template v-slot:prepend-inner>
                            <div align="center">
                              <v-icon color="primary">mdi-email</v-icon>
                            </div>
                          </template>
                        </v-text-field>

                        <v-btn class="fontVariant3 rounded-lg" block size="large" variant="flat" :loading="loading"
                          color="primary" @click="validateSignInForm()">Send otp</v-btn>
                      </v-form>

                      <v-divider class="my-6"></v-divider>
                    </v-window-item>
                    <v-window-item :value="2">
                      <div align="end">
                        <v-icon color="primary" @click="goBacktoStep01">mdi-arrow-left-bold</v-icon>
                      </div>
                      <h1 class="mb-1 text-center">Welcome Back!</h1>
                      <p class="fontVariant3 mb-4 text-center">
                        Please enter the OTP that was sent to your registered
                        EmailID:
                      </p>
                      <v-card-text class="pa-2">
                        <v-otp-input autofocus ref="otpInput" elevation="0" :length="6" v-model="otp"
                          :loading="otpLoading" @keydown.enter.prevent="validateVerifyOtpMethod"></v-otp-input>
                        <div class="d-flex align-center mx-3 mb-2">
                          <v-btn :disabled="otp.length < 6 || otpLoading" class="fontVariant3" block variant="flat"
                            :loading="loading" color="primary" @click="validateVerifyOtpMethod()">Login</v-btn>
                        </div>

                        <div class="fontVariant3 text-center mt-6">
                          <div class="my-2">
                            <v-divider></v-divider>
                          </div>
                          Didn't receive the OTP?
                          <span class="fontVariant3 text-primary cursorPointer"
                            @click="validateSignInForm()">Resend</span>
                          code.
                        </div>
                      </v-card-text>
                    </v-window-item>
                  </v-window>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { signIn, signOut, confirmSignIn } from "aws-amplify/auth";
import { getCurrentUser } from "aws-amplify/auth";
import AssetDetailsPageLoginPage from "../ChildHomePages/AssetDetailsPageWithoutLogin.vue";
import Snackbar from "@/components/Extras/Snackbar.vue";
import Overlay from "@/components/Extras/Overlay.vue";

export default {
  components: {
    Snackbar,
    Overlay,
    AssetDetailsPageLoginPage,
  },

  data() {
    return {
      current_view: "ASSET_DETAILS",
      loading: false,
      overlay: false,
      otpLoading: false,
      mounted: false,
      height: 0,
      windowHeight: 0,
      step: 1,
      EmailID: "",
      otp: "",
      user: "",
      SnackBarComponent: {},
    };
  },

  watch: {
    step(value) {
      if (value && value === 2) {
        this.$nextTick(() => {
          this.$refs.otpInput.focus();
        });
      }
    },
  },
  async mounted() {
    this.windowHeight = window.innerHeight - 50;
  },

  methods: {
    async AssetDetailsPageLoginPageEMit(toggle) {
      if (toggle == 2) {
        await this.checkUserSession();
      }
    },
    async checkUserSession() {
      this.current_view = "LOGIN_PAGE";
      this.overlay = true;
      const qrDisplayId = this.$route.params.qrDisplayId;
      //console.log("qrDisplayId:", qrDisplayId);
      let result = await this.getCurrentUsermethod();
      if (result && result.status === "SUCCESS") {
        this.ActivateMethod();
      } else {
        this.mounted = true;
        this.overlay = false;
      }
    },
    async getCurrentUsermethod() {
      this.overlay = true;
      try {
        const { username, userId, signInDetails } = await getCurrentUser();
        signInDetails.username = username;
        signInDetails.userId = userId;
        //console.log("signInDetails", signInDetails);
        return {
          status: "SUCCESS",
          data: { ...signInDetails },
        };
      } catch (error) {
        //console.log("error", error);
        return {
          status: "ERROR",
          data: error.message,
        };
      } finally {
        this.overlay = false;
      }
    },
    goBacktoStep01() {
      if (this.step === 3) {
        this.$refs.signUpForm.reset();
      } else {
        this.otp = "";
      }
      this.step = 1;
    },

    disableBrowserArrowIcons() {
      //console.log("Domain", window.location.hostname);
      if (window.location.hostname === "localhost") {
        // Push a state to history
        history.pushState(null, null, window.location.href);

        // Add an event listener for the popstate event
        window.addEventListener("popstate", function () {
          // Push the state again to prevent navigation
          history.pushState(null, null, window.location.href);
        });

        //console.log("Navigation buttons disabled on localhost:8081");
      }
    },

    async validateSignInForm() {
      this.otp = "";
      this.loading = true;
      let isValid = await this.$refs.form.validate();
      if (isValid.valid) {
        //console.log("isValid.valid", isValid.valid);
        await this.SignInWithOtpMethod();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: "Fields marked with asterisks (*) are mandatory",
        };
        this.loading = false;
      }
    },

    async SignInWithOtpMethod() {
      //console.log("called");
      try {
        //console.log("this.EmailID.trim()", this.EmailID.trim());
        this.user = await signIn({
          username: this.EmailID.trim(),
          options: {
            authFlowType: "CUSTOM_WITHOUT_SRP",
          },
        });
        //console.log("result of SignInWithOtpMethod step-1", this.user);
        if (
          this.user.nextStep.signInStep ==
          "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
        ) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: `Verification OTP sent to ${this.EmailID}`,
          };
          this.step = 2;
        }
      } catch (error) {
        //console.log("error in SignInWithOtpMethod step-1", error);
        if (error.message == "There is already a signed in user.") {
          await this.logoutMethod(this.EmailID);
        }
        if (
          error.message ===
          "DefineAuthChallenge failed with error Error: NOT_AUTHORIZED : Kindly Sigup."
        ) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            Top: true,
            SnackbarText: "User Not Found",
          };
        }

        let errorMessage =
          error.message ===
          "DefineAuthChallenge failed with error Error: NOT_AUTHORIZED : Kindly Sigup." ||
          error.message == "There is already a signed in user.";
        if (!errorMessage) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            Top: true,
            SnackbarText: error.message,
          };
        }
      } finally {
        this.loading = false;
      }
    },

    async logoutMethod(EmailID) {
      this.loading = true;
      try {
        const user = await signOut({
          username: EmailID,
        });

        await this.validateSignInForm();
      } catch (error) {
        //console.error("Error in logoutMethod", error);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error.message,
        };
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async validateVerifyOtpMethod() {
      this.otpLoading = true;
      //console.log("this.otp", this.otp);
      try {
        let result = await confirmSignIn({ challengeResponse: this.otp });
        //console.log("result", result);
        if (result.nextStep.signInStep === "DONE") {
          this.$store.commit("SET_USER_EMAIL_ID", this.EmailID);
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "Login Success",
          };
          this.ActivateMethod();
        }
      } catch (error) {
        // //console.log("error in validateVerifyOtpMethod ", error);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error.message,
        };
      } finally {
        this.otpLoading = false;
      }
    },
    ActivateMethod() {
      this.otpLoading = true;
      const qrDisplayId = this.$route.params.qrDisplayId;
      //console.log("qrDisplayId:", qrDisplayId);
      setTimeout(() => {
        this.otpLoading = false;
        this.$router.push(`/Web-Form/${qrDisplayId}`);
        this.overlay = false;
      }, 500);
    },
  },
};
</script>

<style scoped>
/* Custom styles for additional polish */

.whole-background {
  background-image: url("@/assets/gradient_blue_background.png");
  background-size: cover;
  background-position: center;
}

.card-background {
  background-image: url("@/assets/LoginPageCard.jpg");
  background-size: cover;
  background-position: center;
  min-height: 550px;
}

.md-and-up-only {
  display: none;
}

@media (min-width: 960px) {
  .md-and-up-only {
    display: block;
  }
}
</style>
